module.exports = __webpack_public_path__ + "img/ST_logo_onwhite.c7478cae.png";